@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100">
        @if (!isReportGenerationStarted) {
            <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ 'i18n_af_incidentAnalyticAgentDialogTitle' | translate }}</div>
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
                {{ 'i18n_af_incidentAnalyticAgentDialogSubtitle' | translate }}
            </div>

            <div class="mt-16 w-100" fxHide [fxShow]="!isReportGenerationStarted">
                <af-dictionary-selector dictionaryName="analytic_agent_report_type"
                    [control]="form.controls.reportType"
                    placeholder="i18n_af_placeholderSelectDocumentType"/>
            </div>
        } @else if (isReportGenerationStarted && !Spinner.isShown('analyticAgentReportLoading')) {
            <ui-kit-svg class="i-80 c-secondary-yellow-500" [name]="reportFile ? 'ic_approved' : 'ic_warning'"/>

            <div class="h3-semi-bold c-primary-gray-900 text-center">
                {{ 'i18n_af_incidentAnalyticAgentDialogTitle#' + form.controls.reportType.value + '#' + (reportFile ? 'success' : 'failed') | translate }}
            </div>
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
                {{ 'i18n_af_incidentAnalyticAgentDialogSubtitle#' + form.controls.reportType.value + '#' + (reportFile ? 'success' : 'failed') | translate }}
            </div>

            <ui-kit-button
                class="mt-32"
                [fxHide]="Spinner.isShown('analyticAgentReportLoading')"
                (clickListener)="downloadOrRetry()"
                [label]="downloadOrRetryLabel | translate"/>
        } @else {
            <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ 'i18n_af_incidentAnalyticAgentDialogTitle#' + form.controls.reportType.value | translate }}</div>
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
                {{ 'i18n_af_incidentAnalyticAgentDialogSubtitle#' + form.controls.reportType.value | translate }}
            </div>
        }

        @if (Spinner.isShown('analyticAgentReportLoading')) {
            <div fxLayout="column" fxLayoutAlign="center center" class="mt-24 mb-24 w-100 h-100">
                <ui-kit-spinner spinnerIds="analyticAgentReportLoading"/>
            </div>
        }
        <ui-kit-button
            fxHide [fxShow]="!isReportGenerationStarted"
            class="mt-32"
            [disabled]="form.invalid"
            (clickListener)="generateAndWaitForAnalyticAgentReport()"
            [label]="'i18n_af_buttonGenerate' | translate"/>
        <ui-kit-button
            class="mt-12"
            type="text"
            (clickListener)="dialogRef.close()"
            [label]="(reportFile ? 'i18n_af_buttonClose' : 'i18n_af_buttonCancel') | translate"/>
    </form>
}
